import { ForecastGlobalRiskBase } from './base/forecast-global-risk-base';

export class ForecastGlobalRisk extends ForecastGlobalRiskBase { }